@if (isVisible()) {
	<div
		class="fixed inset-0 z-1000 overflow-hidden bg-gray-000"
		data-cy="splash-screen"
		role="status"
		aria-live="polite">
		<div class="splash__texture absolute inset-0" [style.background-image]="textureUrl"></div>
		<div class="splash__fade absolute inset-0"></div>
		<div class="splash__glow absolute inset-0"></div>

		<div class="relative flex h-full flex-col items-center justify-center gap-4">
			<div
				class="splash__mark relative size-20 overflow-hidden rounded-3xl border border-stroke-050 bg-gray-000 shadow-xs">
				<ui-icon
					class="splash__mark-outline absolute inset-0 m-auto size-fit"
					width="58"
					height="58"
					viewBox="0 0 58 58"
					aria-hidden="true"
					iconName="easy-kala-mark-outline" />
				<ui-icon
					class="absolute inset-0 m-auto size-fit"
					width="58"
					height="58"
					viewBox="0 0 58 58"
					aria-hidden="true"
					iconName="easy-kala-mark-stripe" />
				<div class="splash__shine-track absolute inset-0 flex items-center justify-center">
					<div class="splash__shine h-60 w-8 shrink-0 -rotate-18"></div>
				</div>
			</div>

			<div class="flex flex-col items-center gap-2.5">
				<ui-icon
					class="splash__wordmark text-gray-800"
					width="88"
					height="24"
					viewBox="0 0 88 24"
					role="img"
					aria-label="ایزی کالا"
					iconName="easy-kala-wordmark-fa" />
				<p class="text-xs leading-normal whitespace-nowrap text-gray-600">
					<span class="sr-only">{{ subtitle }}</span>
					<span class="flex gap-0.5" aria-hidden="true">
						@for (word of subtitleWords; track word) {
							<span class="splash__word">{{ word }}</span>
						}
					</span>
				</p>
			</div>
		</div>

		@if (showLoader()) {
			<ui-loading class="absolute inset-x-0 top-[calc(50%+196px)] mx-auto w-fit" [showMessage]="false" />
		}

		<div
			class="absolute inset-x-0 bottom-(--app-bottom-spacing) mx-auto mb-9.5 flex w-fit items-center gap-1 text-gray-300"
			dir="ltr"
			role="img"
			aria-label="کارگزاری مفید">
			<ui-icon
				width="62.1609"
				height="28.2569"
				viewBox="0 0 62.1609 28.2569"
				aria-hidden="true"
				iconName="mofid-brand-mark" />
			<ui-icon
				width="93.6005"
				height="14.1284"
				viewBox="0 0 93.6005 14.1284"
				aria-hidden="true"
				iconName="mofid-logotype" />
		</div>
	</div>
}
